const INPUT_PATTERNS = {
    ONLY_NUMBERS: /[^0-9]/g,       // 숫자만 허용
    NO_KOREAN: /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g // 한글 제외
};

export default INPUT_PATTERNS;
